import DictionaryTypes from '../../models/dictionary-types';
import Subjects from '../../models/subjects';
import DictionariesService from '../../services/dictionaries';
import { message } from 'antd';
import { runInAction } from 'mobx';

export interface SelectorItem {
    id: string;
    name: string;
}

export abstract class SelectorStore {

    items: SelectorItem[];
    selectedItems: string[];
    subject: Subjects;
    type: DictionaryTypes;
    newItem: string;
    multiple: boolean;

    dictionariesService: DictionariesService;

    constructor(subject: Subjects, type: DictionaryTypes, multiple?: boolean) {
        this.items = [];
        this.selectedItems = [];
        this.subject = subject;
        this.type = type;
        this.newItem = "";
        this.multiple = multiple === undefined ? true : multiple;
        this.dictionariesService = new DictionariesService();
    }

    loadDictionary = async () => {
        try {
            const data = await this.dictionariesService.getDictionary(this.subject, this.type).catch();

            runInAction(() => {
                this.items = data;
            });
        } catch (error) {
            runInAction(() => { message.error(error) });
        }
    }

    setNewItem(name: string) {
        if (name) {
            this.newItem = name;
        }
    }

    createItem(): void {
        if (this.newItem) {
            try {
                this.dictionariesService.createItem(this.subject, this.newItem, this.type).then(
                    response => {
                        if (response.ok) {
                            this.loadDictionary();
                            this.newItem = "";
                        } else {
                            response.json().then(error => message.error(error['detail']));
                        }
                    }
                );
            } catch (error) {
                runInAction(() => { message.error(error) });
            }
        }
    }

    reset(): void {
        this.selectedItems = [];
        console.log("see" + this.selectedItems);
    }

    selectItem(value: string[]): void {
        this.selectedItems = value;
    }

    get selectedItemAsNumber(): number | null {
        return this.selectedItems.length === 0 ? null : Number(this.selectedItems[0]);
    }

    get selectedItemValue(): string {
        if (this.selectedItems.length === 0) return '';

        return this.items
            .filter(item => this.selectedItems.includes(item.id))
            .map(item => item.name)
            .reduce((acc, item) => acc + ', ' + item);
    }
}